import type { StepConfig } from "@portal/components/multiform/types";
import { FinancialsStep } from "../../../../../agent/account/create/steps/financials/FinancialsStep";
import { FinancialsSummary } from "../../../../../agent/account/create/steps/financials/FinancialsSummary";
import type { AdminCombinedFormData } from "../../schema";

export const financialsStepConfig: StepConfig<AdminCombinedFormData> = {
	name: "financials",
	label: "Financials",
	fieldPaths: ["account.financials"],
	component: FinancialsStep,
	summaryComponent: FinancialsSummary,
};
